import { CommunicationSizeComponent, ComponentIds } from '@inter-ikea-core/core';
import { CoreApi, ProductType } from '@inter-ikea-storageone/range';

/**
 * Determines whether to show the layout or single interiors when entering the tab.
 *
 * @param {CoreApi} coreApi - The core API instance.
 * @returns {boolean} - Returns true if the layout should be shown, otherwise false.
 */
export const showLayoutWhenEnteringTab = (coreApi: CoreApi): boolean => {
  const frames = coreApi.entities
    .getByComponent(ComponentIds.FRAME_COMPONENT_ID)
    .filter(e => coreApi.entities.isProductType(e, ProductType.JONAXEL_FRAME));

  const shelvingUnits = coreApi.entities
    .getByComponent(ComponentIds.FRAME_COMPONENT_ID)
    .filter(
      e =>
        coreApi.entities.isProductType(e, ProductType.JONAXEL_FRAME_SHELF) &&
        e.getComponent<CommunicationSizeComponent>(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)
          ?.size.width === 500
    );

  if (frames.length === 0) {
    return shelvingUnits.length === 0;
  }

  return true;
};
